export const GET_FILING_TYPES_REQUEST = 'GET_FILING_TYPES_REQUEST';
export const GET_FILING_TYPES_SUCCESS = 'GET_FILING_TYPES_SUCCESS';
export const GET_FILING_TYPES_FAILURE = 'GET_FILING_TYPES_FAILURE';
export const ADD_SELECTED_FILING_TYPES = 'ADD_SELECTED_FILING_TYPES';
